var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgExclamation(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11 9.04541H13V7.04541H11M12 20.0454C7.59 20.0454 4 16.4554 4 12.0454C4 7.63541 7.59 4.04541 12 4.04541C16.41 4.04541 20 7.63541 20 12.0454C20 16.4554 16.41 20.0454 12 20.0454ZM12 2.04541C10.6868 2.04541 9.38642 2.30407 8.17317 2.80661C6.95991 3.30916 5.85752 4.04576 4.92893 4.97434C3.05357 6.84971 2 9.39325 2 12.0454C2 14.6976 3.05357 17.2411 4.92893 19.1165C5.85752 20.0451 6.95991 20.7817 8.17317 21.2842C9.38642 21.7868 10.6868 22.0454 12 22.0454C14.6522 22.0454 17.1957 20.9918 19.0711 19.1165C20.9464 17.2411 22 14.6976 22 12.0454C22 10.7322 21.7413 9.43183 21.2388 8.21858C20.7362 7.00532 19.9997 5.90293 19.0711 4.97434C18.1425 4.04576 17.0401 3.30916 15.8268 2.80661C14.6136 2.30407 13.3132 2.04541 12 2.04541ZM11 17.0454H13V11.0454H11V17.0454Z",
    fill: "#7687A7"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgExclamation);
export default __webpack_public_path__ + "static/media/exclamation.6ccd67b59815fdefb382c9591a59e450.svg";
export { ForwardRef as ReactComponent };